import SuggestionSimulatorComponent from "./SuggestionSimulatorComponent";
import { Box, Card, Divider, Grid, TextField, Typography } from "@mui/material";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import { useEffect } from "react";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import MediaWithDynamicURL from "./MediaWithDynamicURL";
import { DYNAMIC_URL_REGEX } from "../../../../constants";
import { MediaHandler } from "./MediaHandler";

export default function RichCardStandAloneDetailsComponent({ richCardStandAloneDetails }) {
    // Determine media height based on configuration
    const getMediaHeight = () => {
        if (richCardStandAloneDetails.mediaHeight === "SHORT_HEIGHT") {
            return "100px";
        }
        if (richCardStandAloneDetails.mediaHeight === "MEDIUM_HEIGHT") {
            return "150px";
        }
        return "150px"; // default
    };

    const mediaHeight = getMediaHeight();

    return (
        <>
            {/* VERTICAL CARD ORIENTATION */}
            {richCardStandAloneDetails.cardOrientation === "VERTICAL" && (
                <Card sx={{
                    border: "1px solid Grey",
                    minHeight: "6vh",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    margin: 3
                }}>
                    <Grid fullWidth>
                        <MediaHandler
                            media={richCardStandAloneDetails.media}
                            thumbnail={richCardStandAloneDetails.thumbnail}
                            height={mediaHeight}
                            width="100%"
                            iconPosition="center"
                        />
                    </Grid>

                    <Grid padding={2}>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                        >
                            {richCardStandAloneDetails.cardTitle}
                        </Typography>

                        <TextField
                            multiline
                            size="small"
                            fullWidth
                            label={null}
                            value={richCardStandAloneDetails.cardDescription}
                            variant="standard"
                            InputProps={{
                                readOnly: true,
                                disableUnderline: true,
                            }}
                            sx={{
                                pointerEvents: "none",
                                backgroundColor: "transparent",
                                "& .MuiInputBase-root": {
                                    border: "none",
                                },
                                "& .MuiInputBase-inputMultiline": {
                                    padding: 0,
                                },
                                margin: 1,
                                fontSize: "0.875rem",
                                color: "black",
                            }}
                        />

                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            flexDirection: "column"
                        }}>
                            {richCardStandAloneDetails?.suggestionsList?.map((suggestions, index) => (
                                <Box key={index} marginTop={1}>
                                    <SuggestionSimulatorComponent suggestion={suggestions} />
                                    <Divider />
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Card>
            )}

            {/* HORIZONTAL CARD ORIENTATION */}
            {richCardStandAloneDetails.cardOrientation === "HORIZONTAL" && (
                <Card sx={{
                    border: "1px solid Grey",
                    minHeight: "12vh",
                    width: "100%",
                    display: "flex",
                    margin: 3
                }}>
                    <Grid container>
                        {/* LEFT ALIGNED MEDIA */}
                        {richCardStandAloneDetails.cardAlignment === "LEFT" && (
                            <Grid item md={4}>
                                <MediaHandler
                                    media={richCardStandAloneDetails.media}
                                    thumbnail={richCardStandAloneDetails.thumbnail}
                                    height="100%"
                                    width="100%"
                                    iconPosition="left"
                                />
                            </Grid>
                        )}

                        {/* CONTENT SECTION */}
                        <Grid item md={8} padding={2}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                            >
                                {richCardStandAloneDetails.cardTitle}
                            </Typography>

                            <TextField
                                disabled={true}
                                multiline
                                size="small"
                                fullWidth
                                label={null}
                                value={richCardStandAloneDetails.cardDescription}
                                variant="standard"
                                InputProps={{
                                    readOnly: true,
                                    disableUnderline: true,
                                }}
                                sx={{
                                    pointerEvents: "none",
                                    backgroundColor: "transparent",
                                    "& .MuiInputBase-root": {
                                        border: "none",
                                    },
                                    "& .MuiInputBase-inputMultiline": {
                                        padding: 0,
                                    },
                                    margin: 1,
                                    fontSize: "0.875rem",
                                    color: "black",
                                }}
                            />

                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                flexDirection: "column"
                            }}>
                                {richCardStandAloneDetails?.suggestionsList?.map((suggestions, index) => (
                                    <Box key={index} marginTop={1}>
                                        <SuggestionSimulatorComponent suggestion={suggestions} />
                                        <Divider />
                                    </Box>
                                ))}
                            </Box>
                        </Grid>

                        {/* RIGHT ALIGNED MEDIA */}
                        {richCardStandAloneDetails.cardAlignment === "RIGHT" && (
                            <Grid item md={4}>
                                <MediaHandler
                                    media={richCardStandAloneDetails.media}
                                    thumbnail={richCardStandAloneDetails.thumbnail}
                                    height="100%"
                                    width="100%"
                                    iconPosition="right"
                                />
                            </Grid>
                        )}
                    </Grid>
                </Card>
            )}
        </>
    );
};



